import { ServerClient } from 'common/utils/http/http-clients';
import { ISystemConfigurationRead, ISystemConfigurationUpdate } from './configuration.service.types';

class ConfigurationService {
  async getSystemConfiguration(): Promise<ISystemConfigurationRead> {
    const res = await ServerClient.get<ISystemConfigurationRead>(`/configurations/system`);
    return res?.data;
  }
  async updateSystemConfiguration(model: ISystemConfigurationUpdate): Promise<ISystemConfigurationRead> {
    const res = await ServerClient.patch<ISystemConfigurationRead>(`/configurations/system`, model);
    return res?.data;
  }
}

export const configurationService = new ConfigurationService();
export default configurationService;
